import { Eyebrow, SectionHeading, Lead } from "../common/Type";
import { RevealStagger, RevealItem } from "../common/Reveal";
import { industries, complianceLine } from "../../lib/content";

export default function IndustriesGrid({ showHeading = true }) {
  return (
    <section className="relative py-24 md:py-32" data-testid="section-industries">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {showHeading && (
          <div className="max-w-2xl mb-16">
            <Eyebrow className="mb-5">Industries</Eyebrow>
            <SectionHeading>Configured for the way your sector operates.</SectionHeading>
          </div>
        )}

        <RevealStagger className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {industries.map((ind) => (
            <RevealItem key={ind.name} className="kv-card p-6 md:p-7 group">
              <h3 className="font-display text-lg md:text-xl font-medium tracking-tight text-kv-off">{ind.name}</h3>
              <p className="mt-3 font-body text-sm text-kv-grey leading-relaxed">{ind.note}</p>
            </RevealItem>
          ))}
        </RevealStagger>

        <Lead className="mt-10 max-w-3xl text-kv-steel text-sm md:text-base">{complianceLine}</Lead>
      </div>
    </section>
  );
}
